import {
  dynamicRules,
  getCustomFields,
  columnWidth,
  showError,
  validateField,
} from "../../utils/customFields";
import ConfirmModal from "../../views/InterviewProcess/ConfirmModal.vue";
import InputField from "../../components/InputComponents/Input.vue";
import SwitchBox from "../../components/InputComponents/Switch.vue";
import CustomQuillEditor from "../../components/InputComponents/CustomQuillEditor.vue";
import SelectCustom from "../../components/InputComponents/SelectCustom.vue";
import MultiSelectCustom from "../../components/InputComponents/MultiSelectCustom.vue";
import UploadDocument from "../../components/InputComponents/UploadDocument.vue";
import FormTags from "../../components/InputComponents/FormTags.vue";
import DateField from "../../components/InputComponents/DateField.vue";
import toast from "./toast.js";
import AssignSinglePositionID from "../../components/Kanban/modal/AssignSinglePositionID.vue";
import AddCandidatesToJob from "../../components/Kanban/modal/AddCandidatesToJob.vue";
import {
  addCandidate,
  uploadDocumentAPI,
  putCandidate,
  getTalentPoolCandidate,
  getRegisterJob,
  patchApplyJob,
  postApplyJob,
  getAuthRegisterJob,
  addSlotCandidate,
  uploadSlotdDocumentAPI,
  getMyPositionID,
  resumeParser,
} from "../../utils/apiFunctions.js";

import FormShimmer from "../../components/fixedcomponents/FormShimmer.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import Loader from "../../components/fixedcomponents/Loader.vue";
import { mapGetters } from "vuex";
const candidateData = {
  name: "AddCandidate",
  data() {
    return {
      parsedData: {},

      showResumeLoader: false,
      lengthError: {},
      mergedArray: [],
      customFieldsArray: [],
      basicArray: [],
      advanceArray: [],
      touchedFields: {},
      newObject: {
        customFields: {},
      },
      validations: {
        customFields: {},
      },
      valText: {
        customFields: {},
      },
      LoaderStatus: false,
      shimmerLoader: false,
      failure: false,
      items: [],
      positionIDs: [],
      showSingleAssign: false,
      showAddCands: false,
      showAssignPositionIDs: false,
      regFields: [
        {
          label: "Resume",
          controlType: "upload_file",
          placeholder: "Resume",
          mandatory: false,
          limit: null,
          values: [],
          maxFileSize: "5",
          dateTimeFormat: "",
          fileFormat: ["DOC", "DOCX", "PDF"],
          key: "resume",
          fieldType: "default",
          dropdown: false,
          multi: false,
          apiEndpoint: "",
          sort: false,
          sortType: null,
          filter: false,
          search: false,
          category: 1,
          seq: 1,
          hide: false,
        },
        {
          label: "Name",
          key: "name",
          controlType: "text",
          seq: 2,
          fieldType: "default",
          mandatory: true,
          placeholder: "Enter Candidate name",
          limit: 50,
          dropdown: false,
          values: [],
          multi: false,
          apiEndpoint: null,
          dateTimeFormat: "",
          maxFileSize: null,
          category: 1,
          sort: true,
          sortType: 1,
          filter: false,
          search: true,
          createdAt: "2024-03-20T07:38:31.937Z",
          hide: false,
        },
        {
          label: "Email",
          key: "email",
          controlType: "email",
          seq: 3,
          fieldType: "default",
          mandatory: true,
          placeholder: "e.g. name@example.com",
          limit: 74,
          dropdown: false,
          values: [],
          multi: false,
          apiEndpoint: null,
          dateTimeFormat: "",
          maxFileSize: null,
          category: 1,
          sort: true,
          sortType: 1,
          filter: false,
          search: true,
          createdAt: "2024-03-20T07:38:31.937Z",
          hide: false,
        },
        {
          label: "Phone Number",
          controlType: "number",
          placeholder: "Enter Phone Number",
          mandatory: true,
          limit: "10",
          values: [],
          maxFileSize: null,
          dateTimeFormat: null,
          fileFormat: null,
          key: "phoneNumber",
          fieldType: "default",
          dropdown: false,
          multi: false,
          apiEndpoint: "",
          sort: true,
          sortType: null,
          filter: false,
          search: true,
          category: 1,
          seq: 4,
          hide: false,
        },
        {
          label: "Source",
          controlType: "single_select",
          placeholder: "Choose Source",
          mandatory: true,
          limit: null,
          values: [
            {
              label: "Naukri",
              key: "naukri",
              isDefault: false,
              seq: 1,
            },
            {
              label: "Monster",
              key: "monster",
              isDefault: false,
              seq: 2,
            },
            {
              label: "Indeed",
              key: "indeed",
              isDefault: false,
              seq: 3,
            },
            {
              label: "LinkedIn",
              key: "linkedin",
              isDefault: false,
              seq: 4,
            },
            {
              label: "Others",
              key: "other",
              isDefault: false,
              seq: 5,
            },
          ],
          maxFileSize: null,
          dateTimeFormat: "",
          fileFormat: null,
          key: "source",
          fieldType: "default",
          dropdown: true,
          multi: false,
          apiEndpoint: "",
          sort: true,
          sortType: 1,
          filter: true,
          search: true,
          category: 1,
          seq: 5,
          hide: false,
        },
        {
          label: "Other Source",
          key: "otherSource",
          controlType: "text",
          seq: 5,
          fieldType: "default",
          mandatory: false,
          placeholder: "Enter other source",
          limit: 50,
          dropdown: false,
          values: [],
          multi: false,
          apiEndpoint: null,
          dateTimeFormat: "",
          maxFileSize: null,
          category: 1,
          sort: true,
          sortType: 1,
          filter: false,
          search: true,
          createdAt: "2024-03-20T07:38:31.937Z",
          hide: true,
        },
        {
          label: "Experience(In Years)",
          key: "experince",
          controlType: "number",
          seq: 6,
          fieldType: "default",
          mandatory: false,
          placeholder: "Enter Experience",
          limit: 3,
          dropdown: false,
          values: [],
          multi: false,
          dateTimeFormat: "",
          maxFileSize: null,
          category: 1,
          sort: true,
          sortType: 1,
          filter: false,
          search: true,
          createdAt: "2024-03-20T07:38:31.937Z",
          apiEndpoint: "",
          hide: true,
        },
        {
          label: "Skills",
          controlType: "multi_text",
          placeholder: "Enter skills",
          mandatory: false,
          limit: "25",
          values: [],
          maxFileSize: null,
          dateTimeFormat: null,
          fileFormat: [],
          key: "skills",
          fieldType: "default",
          dropdown: false,
          multi: false,
          apiEndpoint: "",
          sort: false,
          sortType: null,
          filter: true,
          search: true,
          category: 1,
          seq: 7,
          hide: true,
        },
      ],
      resumeCheckerFields: [
        {
          label: "Resume",
          controlType: "upload_file",
          placeholder: "Resume",
          mandatory: true,
          limit: null,
          values: [],
          maxFileSize: "5",
          dateTimeFormat: "",
          fileFormat: ["PDF"],
          key: "resume",
          fieldType: "default",
          dropdown: false,
          multi: false,
          apiEndPoint: "",
          sort: false,
          sortType: null,
          filter: false,
          search: false,
          category: 1,
          seq: 1,
          hide: false,
        },
        {
          label: "Full Name",
          key: "name",
          controlType: "text",
          seq: 2,
          fieldType: "default",
          mandatory: true,
          placeholder: "Enter full name",
          limit: 50,
          dropdown: false,
          values: [],
          multi: false,
          apiEndpoint: null,
          dateTimeFormat: "",
          maxFileSize: null,
          category: 1,
          sort: true,
          sortType: 1,
          filter: false,
          search: true,
          createdAt: "2024-03-20T07:38:31.937Z",
          hide: false,
        },
        {
          label: "Christ Reg. No",
          controlType: "number",
          placeholder: "Enter Reg. No",
          mandatory: true,
          limit: "15",
          values: [],
          maxFileSize: null,
          dateTimeFormat: null,
          fileFormat: null,
          key: "regNo",
          fieldType: "customField",
          dropdown: false,
          multi: false,
          apiEndPoint: "",
          sort: true,
          sortType: null,
          filter: false,
          search: true,
          category: 1,
          seq: 3,
          hide: false,
        },
        {
          label: "University Email ID",
          key: "email",
          controlType: "email",
          seq: 4,
          fieldType: "default",
          mandatory: true,
          placeholder: "e.g. name@example.com",
          limit: 74,
          dropdown: false,
          values: [],
          multi: false,
          apiEndpoint: null,
          dateTimeFormat: "",
          maxFileSize: null,
          category: 1,
          sort: true,
          sortType: 1,
          filter: false,
          search: true,
          createdAt: "2024-03-20T07:38:31.937Z",
          hide: false,
        },
        {
          label: "Mobile No",
          controlType: "number",
          placeholder: "Enter Mobile No",
          mandatory: true,
          limit: "10",
          values: [],
          maxFileSize: null,
          dateTimeFormat: null,
          fileFormat: null,
          key: "phoneNumber",
          fieldType: "default",
          dropdown: false,
          multi: false,
          apiEndPoint: "",
          sort: true,
          sortType: null,
          filter: false,
          search: true,
          category: 1,
          seq: 5,
          hide: false,
        },
        {
          label: "Source",
          controlType: "single_select",
          placeholder: "Choose Source",
          mandatory: true,
          limit: null,
          values: [
            {
              label: "Naukri",
              key: "naukri",
              isDefault: false,
              seq: 1,
            },
            {
              label: "Monster",
              key: "monster",
              isDefault: false,
              seq: 2,
            },
            {
              label: "Indeed",
              key: "indeed",
              isDefault: false,
              seq: 3,
            },
            {
              label: "LinkedIn",
              key: "linkedin",
              isDefault: false,
              seq: 4,
            },
            {
              label: "Others",
              key: "other",
              isDefault: false,
              seq: 5,
            },
          ],
          maxFileSize: null,
          dateTimeFormat: "",
          fileFormat: null,
          key: "source",
          fieldType: "default",
          dropdown: true,
          multi: false,
          apiEndPoint: "",
          sort: true,
          sortType: 1,
          filter: true,
          search: true,
          category: 1,
          seq: 6,
          hide: false,
        },
        {
          label: "Other Source",
          key: "otherSource",
          controlType: "text",
          seq: 6,
          fieldType: "default",
          mandatory: false,
          placeholder: "Enter other source",
          limit: 50,
          dropdown: false,
          values: [],
          multi: false,
          apiEndpoint: null,
          dateTimeFormat: "",
          maxFileSize: null,
          category: 1,
          sort: true,
          sortType: 1,
          filter: false,
          search: true,
          createdAt: "2024-03-20T07:38:31.937Z",
          hide: true,
        },
        {
          label: "Experience(In Years)",
          key: "experince",
          controlType: "number",
          seq: 7,
          fieldType: "default",
          mandatory: false,
          placeholder: "Enter Experience",
          limit: 3,
          dropdown: false,
          values: [],
          multi: false,
          dateTimeFormat: "",
          maxFileSize: null,
          category: 1,
          sort: true,
          sortType: 1,
          filter: false,
          search: true,
          createdAt: "2024-03-20T07:38:31.937Z",
          apiEndPoint: "",
          hide: true,
        },
        {
          label: "Skills",
          controlType: "multi_text",
          placeholder: "Enter skills",
          mandatory: false,
          limit: "25",
          values: [],
          maxFileSize: null,
          dateTimeFormat: null,
          fileFormat: [],
          key: "skills",
          fieldType: "default",
          dropdown: false,
          multi: false,
          apiEndPoint: "",
          sort: false,
          sortType: null,
          filter: true,
          search: true,
          category: 1,
          seq: 8,
          hide: true,
        },
        {
          label: "Degree",
          controlType: "single_select",
          placeholder: "Choose Degree",
          mandatory: true,
          limit: null,
          values: [
            {
              label: "Undergraduate (UG)",
              key: "ug",
              isDefault: false,
              seq: 1,
            },
            {
              label: "Postgraduate (PG)",
              key: "pg",
              isDefault: false,
              seq: 2,
            },
          ],
          maxFileSize: null,
          dateTimeFormat: "",
          fileFormat: null,
          key: "degree",
          fieldType: "customField",
          dropdown: true,
          multi: false,
          apiEndPoint: "",
          sort: true,
          sortType: 1,
          filter: true,
          search: true,
          category: 1,
          seq: 9,
          hide: false,
        },
        {
          label: "Program",
          controlType: "single_select",
          placeholder: "Choose Program",
          mandatory: true,
          limit: null,
          values: [
            {
              label: "Master of Arts Applied Economics",
              key: "Master of Arts Applied Economics",
              isDefault: false,
              seq: 1,
            },
            {
              label: "Master of Arts English with Communication Studies",
              key: "Master of Arts English with Communication Studies",
              isDefault: false,
              seq: 2,
            },
            {
              label: "Master of Science Clinical Psychology",
              key: "Master of Science Clinical Psychology",
              isDefault: false,
              seq: 3,
            },
            {
              label: "Master of Commerce",
              key: "Master of Commerce",
              isDefault: false,
              seq: 4,
            },
            {
              label: "Master of Data Science",
              key: "Master of Data Science",
              isDefault: false,
              seq: 5,
            },
            {
              label: "Bachelor of Arts (Communication and Media, Psychology)",
              key: "Bachelor of Arts (Communication and Media, Psychology)",
              isDefault: false,
              seq: 6,
            },
            {
              label: "Bachelor of Arts (Psychology, Economics)",
              key: "Bachelor of Arts (Psychology, Economics)",
              isDefault: false,
              seq: 7,
            },
            {
              label: "Bachelor of Arts (Psychology, English)",
              key: "Bachelor of Arts (Psychology, English)",
              isDefault: false,
              seq: 8,
            },
            {
              label: "Bachelor of Arts Economics (Honours)",
              key: "Bachelor of Arts Economics (Honours)",
              isDefault: false,
              seq: 9,
            },
            {
              label: "Bachelor of Science Psychology (Honours)",
              key: "Bachelor of Science Psychology (Honours)",
              isDefault: false,
              seq: 10,
            },
            {
              label: "Bachelor of Computer Applications (BCA)",
              key: "Bachelor of Computer Applications (BCA)",
              isDefault: false,
              seq: 11,
            },
            {
              label: "Bachelor of Science (Computer Science, Mathematics)",
              key: "Bachelor of Science (Computer Science, Mathematics)",
              isDefault: false,
              seq: 12,
            },
            {
              label: "Bachelor of Science (Economics, Mathematics)",
              key: "Bachelor of Science (Economics, Mathematics)",
              isDefault: false,
              seq: 13,
            },
            {
              label: "Bachelor of Business Administration (BBA)",
              key: "Bachelor of Business Administration (BBA)",
              isDefault: false,
              seq: 14,
            },
            {
              label:
                "Bachelor of Business Administration (BBA) - Finance and Accountancy",
              key: "Bachelor of Business Administration (BBA) - Finance and Accountancy",
              isDefault: false,
              seq: 15,
            },
            {
              label:
                "Bachelor of Business Administration (BBA) - Finance and International Business",
              key: "Bachelor of Business Administration (BBA) - Finance and International Business",
              isDefault: false,
              seq: 16,
            },
            {
              label: "Bachelor of Business Administration (BBA) - Honours",
              key: "Bachelor of Business Administration (BBA) - Honours",
              isDefault: false,
              seq: 17,
            },
            {
              label: "Bachelor of Commerce (BCom)",
              key: "Bachelor of Commerce (BCom)",
              isDefault: false,
              seq: 18,
            },
            {
              label: "Bachelor of Commerce (Honours)",
              key: "Bachelor of Commerce (Honours)",
              isDefault: false,
              seq: 19,
            },
            {
              label: "Bachelor of Commerce (Finance and Accountancy)",
              key: "Bachelor of Commerce (Finance and Accountancy)",
              isDefault: false,
              seq: 20,
            },
            {
              label:
                "BCom (Finance and Accountancy) (Integrated with CPA Australia)",
              key: "BCom (Finance and Accountancy) (Integrated with CPA Australia)",
              isDefault: false,
              seq: 21,
            },
          ],
          maxFileSize: null,
          dateTimeFormat: "",
          fileFormat: null,
          key: "program",
          fieldType: "customField",
          dropdown: true,
          multi: false,
          apiEndPoint: "",
          sort: true,
          sortType: 1,
          filter: true,
          search: true,
          category: 1,
          seq: 10,
          hide: false,
        },
      ],
    };
  },
  components: {
    ConfirmModal,
    InputField,
    SwitchBox,
    CustomQuillEditor,
    SelectCustom,
    MultiSelectCustom,
    UploadDocument,
    FormTags,
    DateField,
    FormShimmer,
    Loader,
    Spinner,
    AssignSinglePositionID,
    AddCandidatesToJob,
  },
  mixins: [toast],
  async created() {
    this.shimmerLoader = true;
    if (this.$route.name == "JobRegistration") {
      this.getJobDetails();
    } else if (this.$route.name == "Registration") {
      this.getAuthJobDetails();
    } else if (this.$route.name == "ResumeChecker") {
      this.getResumeCheckerJob();
    } else if (
      this.$route.name == "EditCandidate" ||
      this.$route.name == "ActivateCandidate"
    ) {
      await this.getCandidate();
    } else {
      await this.initializeData("add");
    }
    if (this.$route.query.jobID && !this.$route.query.vendorID) {
      await this.getMyPositionIDs();
    }
  },

  computed: {
    ...mapGetters("jobDescriptionVUEX", {
      customerDetail: "getCustomerDetail",
    }),
  },
  methods: {
    setLengthError(value, field) {
      this.lengthError[field.key] = value;
      this.$forceUpdate();
    },
    isValidPhoneNumber(value) {
      return /^\d{7,10}$/.test(value);
    },
    checkForExistingValues(newVal) {
      let hasFields = Object.keys(newVal).some(
        (key) =>
          key !== "customFields" &&
          key !== "resume" &&
          newVal[key] !== "" &&
          newVal[key] !== null &&
          (!Array.isArray(newVal[key]) || newVal[key].length > 0)
      );

      if (!hasFields) {
        hasFields = Object.keys(newVal.customFields || {}).some(
          (key) =>
            !key.startsWith("CUSTFIELD_5") &&
            typeof newVal.customFields[key] !== "boolean" &&
            newVal.customFields[key] !== "" &&
            newVal.customFields[key] !== null &&
            (!Array.isArray(newVal.customFields[key]) ||
              newVal.customFields[key].length > 0)
        );
      }

      return hasFields;
    },

    applyParsedData() {
      Object.keys(this.parsedData).forEach((key) => {
        const value = this.parsedData[key];
        if (
          (this.$route.name === "EditCandidate" ||
            this.$route.name === "ActivateCandidate") &&
          key === "email"
        ) {
          return;
        }
        if (typeof value === "string" && value.startsWith("default")) {
          return;
        }

        if (
          key in this.newObject &&
          typeof this.newObject[key] === typeof value &&
          (key === "phoneNumber" ? this.isValidPhoneNumber(value) : true) &&
          (key === "resume" ? false : true)
        ) {
          this.$set(this.newObject, key, value);
        } else if (
          key in this.newObject.customFields &&
          typeof this.newObject.customFields[key] === typeof value
        ) {
          this.$set(this.newObject.customFields, key, value);
        }
      });

      this.$bvModal.hide("confirmationmsg");
    },

    checkAndCloseModal(type) {
      if (type == "manual") {
        this.closeSingleAssign();
        this.closeAddCandidates();
      } else if (type == "automatic") {
        this.closeAddCandidates();
      }
    },
    closeSingleAssign() {
      this.showSingleAssign = false;
    },
    addSingleCand(cand) {
      this.items = cand;
      this.addCandidate("manual");
    },
    closeAddCandidates() {
      this.showAddCands = false;
    },
    showAssignModal(cand) {
      this.items.push(cand);
      this.showSingleAssign = true;
    },
    showAddCand(data) {
      this.items = data;
      this.showAddCands = true;
    },
    async getMyPositionIDs() {
      try {
        let payload = {
          type: 1,
          jobID: this.$route.query.jobID,
          lead: this.customerDetail.lead,
        };
        const res = await getMyPositionID(payload);
        if (res.status == 200) {
          this.positionIDs = res.data.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    gotoPosition(value) {
      if (value == 2) {
        this.showSingleAssign = true;
      } else {
        this.addCandidate("automatic");
      }
    },
    async initializeData(type) {
      const response = await getCustomFields("5", type);
      if (response.length) {
        if (type == "add") {
          [
            this.customFieldsArray,
            this.newObject,
            this.touchedFields,
            this.mergedArray,
          ] = response;
        } else {
          [this.customFieldsArray, this.touchedFields, this.mergedArray] =
            response;
        }
        this.validations = dynamicRules(this.customFieldsArray);
        if (type == "edit") {
          var foundOthers = false;
          for (var k = 0; k < this.customFieldsArray.length; k++) {
            if (
              this.customFieldsArray[k].key == "noticePeriod" &&
              this.newObject.customFields[this.customFieldsArray[k].key] !==
                "other"
            ) {
              this.newObject.customFields.otherNoticePeriod = null;
            }
            if (
              this.customFieldsArray[k].key == "noticePeriod" &&
              this.newObject.customFields[this.customFieldsArray[k].key] ===
                "other"
            ) {
              var advanceSeqId = this.customFieldsArray[k].seq;
              for (var l = 0; l < this.customFieldsArray.length; l++) {
                if (
                  this.customFieldsArray[l].seq === advanceSeqId &&
                  this.customFieldsArray[l].hide === true
                ) {
                  this.customFieldsArray[l].hide = false;
                  this.customFieldsArray[l].mandatory = true;
                  if (
                    this.advanceArray[l]?.key &&
                    this.newObject.customFields[this.advanceArray[l].key]
                  ) {
                    this.newObject.customFields[this.customFieldsArray[l].key] =
                      this.extractNumbers(
                        this.newObject.customFields[
                          this.customFieldsArray[l].key
                        ]
                      );
                  }
                  this.updateValidations(this.customFieldsArray[l]);
                  foundOthers = true;
                  break; // No need to continue once updated
                }
              }
              if (foundOthers) {
                break; // No need to continue searching once updated
              }
            }
          }
        }
        // Iterate through the original array and push objects into respective arrays based on category value
        this.customFieldsArray.forEach((obj) => {
          if (obj.category === 1 || obj.category === null) {
            this.basicArray.push(obj); // Push objects with category value 1 into category1Array
          } else if (obj.category === 2) {
            this.advanceArray.push(obj); // Push objects with category value 2 into category2Array
          }
        });
        if (type == "edit") {
          var found = false;
          for (var i = 0; i < this.basicArray.length; i++) {
            if (
              this.basicArray[i].key == "source" &&
              this.newObject[this.basicArray[i].key] === "other"
            ) {
              var seqId = this.basicArray[i].seq;
              for (var j = 0; j < this.basicArray.length; j++) {
                if (
                  this.basicArray[j].seq === seqId &&
                  this.basicArray[j].hide === true
                ) {
                  this.basicArray[j].hide = false;
                  this.basicArray[j].mandatory = true;
                  this.updateValidations(this.basicArray[j]);
                  found = true;
                  break; // No need to continue once updated
                }
              }
              if (found) {
                break; // No need to continue searching once updated
              }
            }
          }
        }

        this.shimmerLoader = false;
      }
    },
    extractNumbers(inputString) {
      const hasAlphabetsOrSpecialChars = /[a-zA-Z!@#$%^&*(),.?":{}|<>]/.test(
        inputString
      );
      if (hasAlphabetsOrSpecialChars) {
        const numbersOnly = inputString.match(/\d+/g)?.join("") || ""; // Matches all numbers and joins them
        return numbersOnly;
      } else {
        return inputString;
      }
    },

    updateValidations(field) {
      if (field.fieldType == "default") {
        this.validations[field.key].required = field.mandatory;
      } else {
        this.validations["customFields"][field.key].required = field.mandatory;
      }
      this.$forceUpdate();
    },

    async getJobDetails() {
      this.jobDataLoader = true;

      if (
        this.$route.params.jobID == "L082623A001CU002JD013" ||
        this.$route.params.jobID == "L082623A001CU002JD012"
      ) {
        this.$router.push({
          name: "JobNotFound",
        });
      } else {
        try {
          const res = await getRegisterJob(this.$route.params.jobID);
          if (res.status == 200) {
            this.jobData = res.data.data;
            this.customFieldsArray = [];
            this.basicArray = [];
            this.advanceArray = [];
            this.validations = {};
            this.newObject = {};
            const fields = this.jobData.fields;
            const object = {
              customFields: {},
            };
            const touchedFields = {};
            fields.forEach((field) => {
              if (field.fieldType == "default") {
                field.controlType == "multi_select" ||
                field.controlType === "multi_text"
                  ? (object[field.key] = [])
                  : field.controlType === "boolean"
                  ? (object[field.key] = false)
                  : (object[field.key] = "");
                touchedFields[field.key] = false;
              } else {
                field.controlType == "multi_select" ||
                field.controlType === "multi_text"
                  ? (object["customFields"][field.key] = [])
                  : field.controlType === "boolean"
                  ? (object["customFields"][field.key] = false)
                  : (object["customFields"][field.key] = "");
                touchedFields[field.key] = false;
              }
            });
            this.touchedFields = touchedFields;
            this.newObject = object;
            this.customFieldsArray = fields;
            this.customFieldsArray.forEach((obj) => {
              if (obj.category === 1 || obj.category === null) {
                this.basicArray.push(obj); // Push objects with category value 1 into category1Array
              } else if (obj.category === 2) {
                this.advanceArray.push(obj); // Push objects with category value 2 into category2Array
              }
            });
            this.validations = dynamicRules(this.customFieldsArray);
            this.jobDataLoader = false;
          } else if (res.status == 409) {
            this.$router.push({
              name: "JobNotFound",
            });
          }
        } catch (error) {
          if (error.response.status == 409) {
            this.$router.push({
              name: "JobNotFound",
            });
          }
        }
      }
    },
    async getResumeCheckerJob() {
      this.jobDataLoader = true;
      this.customFieldsArray = [];
      this.basicArray = [];
      this.advanceArray = [];
      this.validations = {};
      this.newObject = {};
      this.customFieldsTemplate = {};
      try {
        var jobID = "L082623A001CU002JD011";
        const res = await getAuthRegisterJob(jobID);
        if (res.status == 200) {
          this.jobData = res.data.data;
          // const fields = this.jobData.fields;
          const fields = this.resumeCheckerFields;
          const object = {
            customFields: {},
          };
          const touchedFields = {};
          fields.forEach((field) => {
            if (field.fieldType == "default") {
              field.controlType == "multi_select" ||
              field.controlType === "multi_text"
                ? (object[field.key] = [])
                : field.controlType === "boolean"
                ? (object[field.key] = false)
                : (object[field.key] = "");
              touchedFields[field.key] = false;
            } else {
              field.controlType == "multi_select" ||
              field.controlType === "multi_text"
                ? (object["customFields"][field.key] = [])
                : field.controlType === "boolean"
                ? (object["customFields"][field.key] = false)
                : (object["customFields"][field.key] = "");
              touchedFields[field.key] = false;
            }
          });
          this.touchedFields = touchedFields;
          this.newObject = object;
          this.customFieldsTemplate = object;
          this.customFieldsArray = fields;
          this.customFieldsArray.forEach((obj) => {
            if (obj.category === 1 || obj.category === null) {
              this.basicArray.push(obj); // Push objects with category value 1 into category1Array
            } else if (obj.category === 2) {
              this.advanceArray.push(obj); // Push objects with category value 2 into category2Array
            }
          });
          this.validations = dynamicRules(this.customFieldsArray);
          this.jobDataLoader = false;
        } else if (res.status == 409) {
          this.$router.push({
            name: "404",
          });
        }
      } catch (error) {
        if (error.response.status == 409) {
          this.$router.push({
            name: "404",
          });
        }
      } finally {
        this.jobDataLoader = false;
      }
    },
    async getAuthJobDetails() {
      this.jobDataLoader = true;
      this.customFieldsArray = [];
      this.basicArray = [];
      this.advanceArray = [];
      this.validations = {};
      this.newObject = {};
      this.customFieldsTemplate = {};
      try {
        var jobID;
        if (this.$route.query.type == "walk-in") {
          jobID = "L082623A001CU001JD002";
        } else if (this.$route.query.jobID) {
          jobID = this.$route.query.jobID;
        } else {
          jobID = "L082623A001CU001JD001";
        }
        const res = await getAuthRegisterJob(jobID);
        if (res.status == 200) {
          this.jobData = res.data.data;
          // const fields = this.jobData.fields;
          const fields = this.regFields;
          const object = {
            customFields: {},
          };
          const touchedFields = {};
          fields.forEach((field) => {
            if (field.fieldType == "default") {
              field.controlType == "multi_select" ||
              field.controlType === "multi_text"
                ? (object[field.key] = [])
                : field.controlType === "boolean"
                ? (object[field.key] = false)
                : (object[field.key] = "");
              touchedFields[field.key] = false;
            } else {
              field.controlType == "multi_select" ||
              field.controlType === "multi_text"
                ? (object["customFields"][field.key] = [])
                : field.controlType === "boolean"
                ? (object["customFields"][field.key] = false)
                : (object["customFields"][field.key] = "");
              touchedFields[field.key] = false;
            }
          });
          this.touchedFields = touchedFields;
          this.newObject = object;
          this.customFieldsTemplate = object;
          this.customFieldsArray = fields;
          this.customFieldsArray.forEach((obj) => {
            if (obj.category === 1 || obj.category === null) {
              this.basicArray.push(obj); // Push objects with category value 1 into category1Array
            } else if (obj.category === 2) {
              this.advanceArray.push(obj); // Push objects with category value 2 into category2Array
            }
          });
          this.validations = dynamicRules(this.customFieldsArray);
          this.jobDataLoader = false;
        } else if (res.status == 409) {
          this.$router.push({
            name: "JobNotFound",
          });
        }
      } catch (error) {
        if (error.response.status == 409) {
          this.$router.push({
            name: "JobNotFound",
          });
        }
      }
    },
    goBackPointer() {
      if (
        this.$route.name == "AddCandidate" ||
        this.$route.name == "AddCandidateInVendor" ||
        this.$route.name == "AddCandidateInJD"
      ) {
        if (this.$route.query.createdBy == "vendor") {
          this.$router.push({
            name: "vendorCandidates",
            params: {
              jobID: this.$route.query.jobID,
              customerID: this.$route.query.customerID,
              customerName:
                this.$route.query.customerName || this.$route.query.cardName,
              title: this.$route.query.title,
            },
          });
        } else if (
          this.$route.query.vendorID ||
          this.$route.name == "AddCandidateInVendor"
        ) {
          this.$router.push({
            name: "VendorKanban",
            query: {
              jobID: this.$route.query.jobID,
              customerName: this.$route.query.customerName,
              clientName: this.$route.query.clientName,
              jobTitle: this.$route.query.jobTitle,
            },
            params: {
              client: this.$route.query.client,
              vendorID: this.$route.query.vendorID,
            },
          });
        } else if (this.$route.name == "AddCandidateInJD") {
          this.$router.push({
            name: "Kanban",
            query: {
              jobID: this.$route.query.jobID,
              customerID: this.$route.query.customerID,
              customerName: this.$route.query.customerName,
              cardName: this.$route.query.cardName,
            },
          });
        } else {
          this.$router.push({
            name: "TalentPool",
            query: {
              advancedSearch: "search",
            },
          });
        }
      } else if (
        this.$route.name == "EditCandidate" ||
        this.$route.name == "EditCandidateInVendor" ||
        this.$route.name == "EditCandidateInJD" ||
        this.$route.name == "ActivateCandidate"
      ) {
        if (this.$route.query.createdBy == "vendor") {
          this.$router.push({
            name: "vendorCandidates",
            params: {
              jobID: this.$route.query.jobID,
              customerID: this.$route.query.customerID,
              title: this.$route.query.title,
            },
          });
        } else if (this.$route.name == "EditCandidateInJD") {
          this.$router.push({
            name: "JdDetails",
            query: {
              jobID: this.$route.query.jobID,
              jobTitle: this.$route.query.jobTitle,
              customerID: this.$route.query.customerID,
              cardName: this.$route.query.cardName,
              status: this.$route.query.status,
            },
          });
        } else if (this.$route.query.fromPage == "bookmark") {
          this.$router.push({
            name: "Bookmark",
            query: this.$route.query,
          });
        } else {
          this.$router.push({
            name: "TalentPool",
          });
        }
      }
    },
    getColumn(field) {
      return columnWidth(field);
    },
    getError(field) {
      return showError(field, this.touchedFields[field.key], this);
    },
    getVmodel(field) {
      return field.fieldType == "default"
        ? this.newObject[field.key]
        : this.newObject.customFields[field.key];
    },
    handleInput(field) {
      this.touchedFields[field.key] = true;
      this.$forceUpdate();
    },
    handleBlur(field) {
      if (this.touchedFields[field.key] && !this.validations[field.key]) {
        this.validateField(field, this);
        this.$forceUpdate();
      }
    },
    async parseResume(field) {
      try {
        this.showResumeLoader = true;
        const hasExistingFieldsBeforeParsing = this.checkForExistingValues(
          this.newObject
        );
        const array =
          this.$route.name == "Registration"
            ? this.jobData.fields
            : this.customFieldsArray;

        const formData = new FormData();
        formData.append("file", this.newObject[field.key]);
        formData.append("candidate_form", JSON.stringify(array));

        const response = await resumeParser(formData);
        this.parsedData = response.data.payload;

        if (hasExistingFieldsBeforeParsing) {
          this.$bvModal.show("confirmationmsg");
        } else {
          this.applyParsedData();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.showResumeLoader = false;
      }
    },

    updateFieldValue(field, value) {
      if (field.fieldType === "default") {
        this.$set(this.newObject, field.key, value);
      } else {
        this.$set(this.newObject.customFields, field.key, value);
      }
      if (field.key === "resume" && value instanceof File) {
        this.parseResume(field);
      }
      if (
        (field.key === "source" || field.key === "noticePeriod") &&
        value === "other"
      ) {
        if (field.category === 1 || field.category === null) {
          const selectedIndex = this.basicArray.findIndex(
            (option) => option.seq === field.seq && option.hide
          );
          if (selectedIndex !== -1) {
            this.basicArray[selectedIndex].hide = false;
            this.basicArray[selectedIndex].mandatory = true;
            this.updateValidations(this.basicArray[selectedIndex]);
          }
        } else {
          const selectedIndex = this.advanceArray.findIndex(
            (option) => option.seq === field.seq && option.hide
          );
          if (selectedIndex !== -1) {
            this.advanceArray[selectedIndex].hide = false;
            this.advanceArray[selectedIndex].mandatory = true;
            this.updateValidations(this.advanceArray[selectedIndex]);
          }
        }
      } else if (field.key === "source" || field.key === "noticePeriod") {
        let otherKey =
          field.key === "source" ? "otherSource" : "otherNoticePeriod";
        let customArray =
          field.category === 1 ? this.basicArray : this.advanceArray;
        const otherSourceIndex = customArray.findIndex(
          (option) => option.key === otherKey
        );
        if (otherSourceIndex !== -1) {
          customArray[otherSourceIndex].hide = true;
          customArray[otherSourceIndex].mandatory = false;
          this.updateValidations(customArray[otherSourceIndex]);
          if (field.category === 1) this.basicArray = customArray;
          else this.advanceArray = customArray;
        }
      }

      this.$forceUpdate();
      this.validateField(field, this);
    },
    validateField(field) {
      return validateField(field, this);
    },
    validateForm() {
      let invalidForm = false;
      if (this.$route.name == "JobRegistration") {
        this.newObject["source"] = "other";
        this.newObject["otherSource"] = "Job Registration";
      }
      for (let i = 0; i < this.customFieldsArray.length; i++) {
        const field = this.customFieldsArray[i];
        this.touchedFields[field.key] = true;
        this.$forceUpdate();
        if (!this.validateField(field, this)) {
          invalidForm = true;
        }
      }
      if (!invalidForm) {
        if (this.newObject.source !== "other")
          this.newObject.otherSource = null;
        if (this.newObject.customFields.noticePeriod !== "other")
          this.newObject.customFields.otherNoticePeriod = null;
        if (this.$route.name == "JobRegistration") {
          this.registerCandidate();
        } else if (
          this.$route.name == "AddCandidate" ||
          this.$route.name == "AddCandidateInJD" ||
          this.$route.name == "AddCandidateInVendor"
        ) {
          if (this.$route.query.jobID && !this.$route.query.vendorID) {
            if (this.positionIDs.length > 1) {
              let anotherCand;
              anotherCand = JSON.parse(JSON.stringify(this.newObject));
              let arr = [];
              arr.push(anotherCand);
              this.showAddCand(arr);
            } else {
              this.addCandidate("automatic");
            }
          } else {
            this.addCandidate();
          }
        } else {
          this.editCandidate();
        }
      } else {
        this.errorModal("Please fill all the details");
      }
    },
    async addCandidate(type) {
      this.LoaderStatus = true;
      let anotherCand;
      anotherCand = JSON.parse(JSON.stringify(this.newObject));
      for (const field of this.customFieldsArray) {
        if (field.controlType === "upload_file") {
          if (field.fieldType === "default") {
            delete anotherCand[field.key];
          } else {
            delete anotherCand.customFields[field.key];
          }
        }
      }
      var payload = {};
      if (this.$route.query.jobID) {
        let data = {
          jobID: this.$route.query.jobID,
          customerID: this.$route.query.customerID,
        };
        if (this.$route.query.vendorID) {
          data.vendorID = this.$route.query.vendorID;
          data.createdBy = "Vendor";
        }
        payload = {
          ...anotherCand,
          ...data,
        };
      } else {
        payload = {
          ...anotherCand,
        };
      }
      if (this.$route.name == "Registration") {
        payload["slot"] = true;
        payload["time"] = this.selectedSlot.time;
        payload["date"] = this.selectedSlot.date;
        payload["jobID"] = this.jobData.jobID;
        payload["customerID"] = this.jobData.customerID;
      }
      if (type && type == "manual") {
        let positionValues = {};
        this.items.map((obj) => {
          positionValues[obj.email] = obj.positionID;
        });
        payload.positions = positionValues;
      }
      if (type && type == "automatic") payload.automatic = true;
      const res = await addCandidate(payload);
      if (res.status == 200 || res.status == 201) {
        const form = new FormData();
        form.append("type", "5");
        form.append("candidateID", res.data.data.Details);

        var attachment = [];

        // Iterate over custom fields to append data to FormData object
        for (const field of this.customFieldsArray) {
          const key =
            field.fieldType === "default"
              ? this.newObject[field.key]
              : this.newObject.customFields[field.key];
          if (field.controlType === "upload_file" && key) {
            let obj = {
              attachmentName: field.key,
            };
            attachment.push(obj);
            form.append(field.key, key);
          }
        }
        form.append("attachment", JSON.stringify(attachment));
        if (payload.jobID && !this.$route.query.vendorID)
          form.append("jobID", payload.jobID);
        await uploadDocumentAPI(form);

        if (type) {
          this.showSingleAssign = false;
          this.showAddCands = false;
          this.showAssignPositionIDs = false;
        }
        // this.$nextTick(() => {
        this.successModal("Candidate Added Successfully");
        // });
        setTimeout(() => {
          this.goBackPointer();
        }, 300);
      } else if (res.status == 208) {
        if (type) {
          this.checkAndCloseModal(type);
        }
        this.LoaderStatus = false;
      } else if (res.status == 409) {
        if (type) {
          this.checkAndCloseModal(type);
        }
        this.LoaderStatus = false;
        let errorMessage = res.data.data.Detail;
        this.errorModal(`${errorMessage}`);
      } else {
        if (type) {
          this.checkAndCloseModal(type);
        }
        this.LoaderStatus = false;
        this.errorModal("Something went wrong");
      }
    },
    async editCandidate() {
      try {
        if (this.$route.name == "ActivateCandidate") {
          this.newObject.active = true;
        }
        this.LoaderStatus = true;
        let anotherCand;
        anotherCand = JSON.parse(JSON.stringify(this.newObject));
        for (const field of this.customFieldsArray) {
          if (field.controlType === "upload_file" && field.isReupload) {
            if (field.fieldType === "default") {
              delete anotherCand[field.key];
            } else {
              delete anotherCand.customFields[field.key];
            }
          }
        }
        let payload = {
          ...anotherCand,
        };

        const res = await putCandidate(payload);
        if (res.status == 200 || res.status == 201) {
          if (this.$route.name === "ActivateCandidate") {
            this.$nextTick(() => {
              this.successModal("Candidate Activated Successfully");
            });
          } else {
            this.successModal("Candidate Updated Successfully");
          }
          this.LoaderStatus = false;
          const form = new FormData();
          form.append("type", "5");
          form.append("candidateID", this.$route.params.candidateID);
          var attachment = [];
          for (const field of this.customFieldsArray) {
            const key =
              field.fieldType === "default"
                ? this.newObject[field.key]
                : this.newObject.customFields[field.key];
            if (
              field.controlType === "upload_file" &&
              field.isReupload &&
              key
            ) {
              let obj = {
                attachmentName: field.key,
              };
              attachment.push(obj);
              form.append(field.key, key);
            }
          }
          form.append("attachment", JSON.stringify(attachment));
          if (attachment.length !== 0) {
            await uploadDocumentAPI(form);
          }
          setTimeout(() => {
            this.goBackPointer();
          }, 300);
        } else if (res.status == 208) {
          this.LoaderStatus = false;
        } else if (res.status == 409) {
          this.LoaderStatus = false;
          let errorMessage = res.data.data.Detail;
          this.errorModal(`${errorMessage}`);
        } else {
          this.LoaderStatus = false;
          this.errorModal("Something went wrong");
        }
      } catch (err) {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong!");
        throw err;
      }
    },
    async getCandidate() {
      let type = "2";
      // if (
      //   this.$route.query.active == true ||
      //   this.$route.query.active == "true"
      // ) {
      //   type = "1";
      // } else {
      //   type = "0";
      // }
      const res = await getTalentPoolCandidate(
        type,
        this.$route.params.candidateID
      );
      if (res.status == 200) {
        this.newObject = res.data.data[0];
        this.initializeData("edit");
      }
    },
    async registerCandidate() {
      this.showSpinner = true;

      try {
        let fieldsExceptUploadTypes;
        fieldsExceptUploadTypes = JSON.parse(JSON.stringify(this.newObject));
        for (const field of this.customFieldsArray) {
          if (field.controlType === "upload_file") {
            if (field.fieldType === "default") {
              delete fieldsExceptUploadTypes[field.key];
            } else {
              delete fieldsExceptUploadTypes.customFields[field.key];
            }
          }
        }
        const res = await postApplyJob({
          emailID: this.newObject.email,
          jobID: this.$route.params.jobID,
          name: this.newObject.name,
          candidateInfo: {
            ...fieldsExceptUploadTypes,
          },
        });
        if (res.status == 200) {
          const form = new FormData();
          var attachment = [];

          for (const field of this.customFieldsArray) {
            const value =
              field.fieldType === "default"
                ? this.newObject[field.key]
                : this.newObject.customFields[field.key];
            if (
              field.controlType === "upload_file" &&
              value &&
              typeof value === "object"
            ) {
              let obj = {
                attachmentName: field.key,
                fieldType: field.fieldType,
              };
              attachment.push(obj);
              form.append(field.key, value);
            }
          }
          form.append("attachment", JSON.stringify(attachment));
          form.append("jobID", this.$route.params.jobID);
          form.append("email", this.newObject.email);
          if (attachment.length) await patchApplyJob(form);
          this.goBack();
          this.dynamicToast("success", "Registered Successfully", "");
          this.getJobDetails();
        } else if (res.status == 400) {
          this.errorModal(res.data.data.Detail);
        } else if (res.status == 409) {
          this.errorModal("Already applied for the Job");
        } else {
          this.errorModal("Something went wrong");
          throw new Error(res.data.data.Detail);
        }
      } catch (error) {
        if (error.response.status == 409) {
          this.errorModal("Already applied for the Job");
        } else if (error.response.status == 400) {
          this.errorModal(error.response.data.data.Detail);
        } else {
          this.errorModal("Something went wrong");
          throw new Error(error);
        }
      } finally {
        this.showSpinner = false;
      }
    },
    async registerSlot() {
      this.LoaderStatus = true;
      let anotherCand;
      anotherCand = JSON.parse(JSON.stringify(this.newObject));
      for (const field of this.customFieldsArray) {
        const value =
          field.fieldType === "default"
            ? this.newObject[field.key]
            : this.newObject.customFields[field.key];
        if (field.controlType === "upload_file" && typeof value === "object") {
          if (field.fieldType === "default") {
            delete anotherCand[field.key];
          } else {
            delete anotherCand.customFields[field.key];
          }
        }
      }
      var payload = {};
      payload = {
        ...anotherCand,
      };
      payload["slot"] = true;
      if (this.$route.query.type != "walk-in" && this.noSlot == false) {
        // payload["time"] = this.selectedSlot.time;
        payload["date"] = this.selectedSlot.date;
      } else if (this.$route.query.jobID === "L082623A001CU002JD010") {
        payload["date"] = "2024-08-21";
      } else {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");

        let todayDate = `${year}-${month}-${day}`;
        payload["date"] = todayDate;
      }
      payload["jobID"] = this.jobData.jobID;
      payload["customerID"] = this.jobData.customerID;
      // payload["endTime"] = this.formatTime(
      //   this.newTime(this.selectedSlot.time)
      // ).toLowerCase();
      const res = await addSlotCandidate(payload);
      if (res.status == 200 || res.status == 201) {
        const form = new FormData();
        form.append("type", "5");
        form.append("candidateID", res.data.data.Details);

        var attachment = [];

        // Iterate over custom fields to append data to FormData object
        for (const field of this.customFieldsArray) {
          const key =
            field.fieldType === "default"
              ? this.newObject[field.key]
              : this.newObject.customFields[field.key];
          if (
            field.controlType === "upload_file" &&
            key &&
            typeof key === "object"
          ) {
            let obj = {
              attachmentName: field.key,
            };
            attachment.push(obj);
            form.append(field.key, key);
          }
        }
        form.append("attachment", JSON.stringify(attachment));
        if (attachment.length > 0) {
          await uploadSlotdDocumentAPI(form);
        }
        // this.$nextTick(() => {
        // this.successModal("Candidate Added Successfully");
        this.openApplyJob = false;
        this.applied = true;
        // });
      } else if (res.status == 208) {
        this.LoaderStatus = false;
      } else if (res.status == 409) {
        this.LoaderStatus = false;
        let errorMessage = "You have already applied for this job";
        this.errorModal(`${errorMessage}`);
      } else {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong");
      }
    },
    async resumeChecker() {
      this.LoaderStatus = true;
      let anotherCand;
      anotherCand = JSON.parse(JSON.stringify(this.newObject));
      for (const field of this.customFieldsArray) {
        const value =
          field.fieldType === "default"
            ? this.newObject[field.key]
            : this.newObject.customFields[field.key];
        if (field.controlType === "upload_file" && typeof value === "object") {
          if (field.fieldType === "default") {
            delete anotherCand[field.key];
          } else {
            delete anotherCand.customFields[field.key];
          }
        }
      }
      var payload = {};
      payload = {
        ...anotherCand,
      };
      payload["jobID"] = this.jobData.jobID;
      payload["customerID"] = this.jobData.customerID;
      const res = await addSlotCandidate(payload);
      if (res.status == 200 || res.status == 201) {
        const form = new FormData();
        form.append("type", "5");
        form.append("candidateID", res.data.data.Details);

        var attachment = [];

        // Iterate over custom fields to append data to FormData object
        for (const field of this.customFieldsArray) {
          const key =
            field.fieldType === "default"
              ? this.newObject[field.key]
              : this.newObject.customFields[field.key];
          if (
            field.controlType === "upload_file" &&
            key &&
            typeof key === "object"
          ) {
            let obj = {
              attachmentName: field.key,
            };
            attachment.push(obj);
            form.append(field.key, key);
          }
        }
        form.append("attachment", JSON.stringify(attachment));
        if (attachment.length > 0) {
          const res2 = await uploadSlotdDocumentAPI(form);
          console.log(res2);
        }
        // this.$nextTick(() => {
        // this.successModal("Candidate Added Successfully");
        this.openApplyJob = false;
        this.applied = true;
        this.LoaderStatus = false;
        // });
      } else if (res.status == 208) {
        this.LoaderStatus = false;
      } else if (res.status == 409) {
        this.LoaderStatus = false;
        let errorMessage = "You have already filled the form";
        this.errorModal(`${errorMessage}`);
      } else {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong");
      }
    },
  },
};

export default candidateData;
